export default "__VITE_ASSET__4f9a4e9c__"